import { useSearchParams } from 'react-router';

import { UrlPagination } from 'DesignSystem/features/pagination/url-pagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';

import { useEventsQuery } from '../events.route';

export default function EventQueuePagination() {
  const loaderData = useEventsQuery();
  const count = loaderData?.count ?? 0;
  const [searchParams] = useSearchParams();
  const page = parseInt(searchParams.get('page') || '1', 10);
  const pageSize = parseInt(searchParams.get('page_size') || DEFAULT_PAGE_SIZE.toString(), 10);
  const maxPage = Math.ceil(count / pageSize);

  return <UrlPagination page={page} pageSize={pageSize} total={count} totalPages={maxPage} />;
}
